import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: { defaultMessage: 'Amount' },
  max: { defaultMessage: 'MAX' },
});
